import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  methods: {
    closeModal() {
      ModalEventBus.close();
    },

    openModal() {
      ModalEventBus.open({
        component: 'ProductTourModal',
        isSmallModal: true,
        isDarkOverlay: true,
        preventCloseOnOverlayClick: true,
      });
    },
  },
};
